import { FormatOoxmlRequest } from '@harvey-frontend/openapi/models/FormatOoxmlRequest'
import { FormatOoxmlResponse } from '@harvey-frontend/openapi/models/FormatOoxmlResponse'
import * as Sentry from '@sentry/react'
import { useMutation } from '@tanstack/react-query'

import { fetchFormatOoxml } from '../../../services/endpoints'
import { ensureError } from '../utils/error-utils'
import { insertOoxmlAtCursor } from '../utils/ooxml-utils'

export interface FormatOoxmlParams {
  instructions: string
  wordDocumentId: string
  textToInsert: string
  ooxmlBefore: string
  ooxmlAfter: string
  inParagraph: boolean
}

export const MUTATION_KEY = 'formatOoxml'

export const useFormatOoxml = () => {
  return useMutation<FormatOoxmlResponse, Error, FormatOoxmlParams>({
    mutationKey: [MUTATION_KEY],
    mutationFn: async (params: FormatOoxmlParams) => {
      const request: FormatOoxmlRequest = {
        instructions: params.instructions,
        wordDocumentId: params.wordDocumentId,
        textToInsert: params.textToInsert,
        ooxmlBefore: params.ooxmlBefore,
        ooxmlAfter: params.ooxmlAfter,
      }

      const formattedOoxml = await fetchFormatOoxml(request)
      try {
        await insertOoxmlAtCursor(
          formattedOoxml.formattedOoxml,
          params.inParagraph
        )
      } catch (e) {
        const error = ensureError(e)
        Sentry.addBreadcrumb({
          data: {
            ooxml: formattedOoxml.formattedOoxml,
            inParagraph: params.inParagraph,
          },
        })
        Sentry.captureException(error)
        throw error
      }
      return formattedOoxml
    },
  })
}
